import { render, staticRenderFns } from "./AccountChamberInfo.vue?vue&type=template&id=252f8973"
import script from "./AccountChamberInfo.vue?vue&type=script&lang=js"
export * from "./AccountChamberInfo.vue?vue&type=script&lang=js"
import style0 from "./AccountChamberInfo.vue?vue&type=style&index=0&id=252f8973&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports